exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../styles/variables/colors.css"), undefined);

// module
exports.push([module.id, "._2oNNROeJLGwRqQNT81YLha {\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n._3hk_LEABHEoxA24T4DYwwn {\n  fill: " + require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../styles/variables/colors.css").locals["dark-grey"] + ";\n  fill-opacity: .2;\n}\n.m64iCRHQouY2ExxhJWWey {\n  width: auto;\n}\n", ""]);

// exports
exports.locals = {
	"dark-grey": "" + require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../styles/variables/colors.css").locals["dark-grey"] + "",
	"markerContainer": "_2oNNROeJLGwRqQNT81YLha",
	"marker": "_3hk_LEABHEoxA24T4DYwwn",
	"markerSvg": "m64iCRHQouY2ExxhJWWey"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Graphs/components/Marker/Marker.css
// module id = 9121
// module chunks = 23